module.exports = __webpack_public_path__ + "img/audio.4f1c24b.svg";